import './TableCells.scss';

type TableProgressCellProps = {
    value: number;
    color?: string;
};
export const TableProgressCell = ({value, color}: TableProgressCellProps) => {
    return (
        <div className="progress-bar-container-table">
            <div className="progress-label-table flex-align-l">
                <label className={"text-black-50 margin-left-s text-center"}>{value.toFixed(0)}%</label>
            </div>
            <div className="progress-bar-table" style={{width: `${value}%`, backgroundColor: color ?? ""}}></div>
        </div>
    );
};
